<template>
    <div>
        <dropdown v-if="displayDropdown">
            <template #triggerbutton>
                <span v-if="hasChip" :class="`chip chip-${chipColor(chip)}`"></span>
                <span class="gray-100 m-0" @mouseover="fetch">
                    {{ label }}
                </span>
            </template>
            <template #content>
                <div v-if="loader" class="absolute-center absolute-full-width">
                    <preloader :display="loader" class="loader-small" />
                </div>
                <div v-else>
                    <div class="content-header">
                        <h4 class="content-header__title typographies-paragraph-medium-bold">
                            {{ label }}
                        </h4>
                        <CompassButton
                            v-if="object === 'tasks'"
                            :label="$t.__('listing.ListingDropdown.plan_task')"
                            type="tertiary"
                            @click="addTask(relatedid, linkedType, step)"
                        />
                    </div>
                    <ul>
                        <li
                            v-for="(element, elementIndex) in data.elements"
                            :key="elementIndex"
                            class="bt-1-lightgrey"
                        >
                            <div
                                :class="`py-2 px-3 chip-border chip-border--${borderChip(
                                    element.chip,
                                )}`"
                            >
                                <p class="semibold ellipsis" v-html="element.bottom" />
                                <p
                                    :class="[element.chip === 'error' ? 'red' : 'gray-60']"
                                    v-html="element.top"
                                />
                            </div>
                        </li>
                    </ul>
                </div>
            </template>
        </dropdown>
        <span v-else>{{ placeholder }}</span>
    </div>
</template>

<script>
import Dropdown from '../utilities/Dropdown.vue';
import Preloader from 'vcomponents/utilities/Preloader.vue';

export default {
    components: {
        Preloader,
        Dropdown,
    },
    props: {
        nbelements: {
            type: Number,
            default: undefined,
        },
        relatedtype: {
            type: String,
            default: undefined,
        },
        relatedid: {
            type: String,
            default: undefined,
        },
        object: {
            type: String,
            default: undefined,
        },
        chip: {
            type: String,
            default: undefined,
        },
        placeholder: {
            type: String,
            default: '-',
        },
        step: {
            type: String,
            default: undefined,
        },
    },
    data() {
        return {
            data: [],
            loader: true,
        };
    },
    computed: {
        label() {
            if (this.displayDropdown) {
                switch (this.object) {
                    case 'tasks':
                        return this.$l10n.n__(
                            '%s tâche',
                            '%s tâches',
                            this.nbelements,
                            this.nbelements,
                        );
                    case 'events':
                        return this.$l10n.n__(
                            '%s évènement',
                            '%s évènements',
                            this.nbelements,
                            this.nbelements,
                        );
                    case 'documents':
                        return this.$l10n.n__(
                            '%s document',
                            '%s documents',
                            this.nbelements,
                            this.nbelements,
                        );
                    case 'projects':
                        return this.$l10n.n__(
                            '%s entrée de projet',
                            '%s entrées de projet',
                            this.nbelements,
                            this.nbelements,
                        );
                    default:
                        return '-';
                }
            } else {
                return '-';
            }
        },
        route() {
            return '/' + this.relatedtype + '/' + this.relatedid + '/' + this.object;
        },
        hasChip() {
            return this.object === 'tasks' || this.chip;
        },
        displayDropdown() {
            return this.object === 'tasks' || this.nbelements > 0;
        },
        linkedType() {
            switch (this.relatedtype) {
                case 'opportunities':
                    return 'opportunity';
                default:
                    return this.relatedtype;
            }
        },
    },
    methods: {
        fetch() {
            const self = this;

            window.axios
                .get(this.route)
                .then(function (response) {
                    self.data = response.data.elements;
                })
                .catch(function (error) {
                    // handle error
                    console.log(error);
                })
                .then(function () {
                    self.loader = false;
                    // always executed
                });
        },
        chipColor(chip) {
            if (chip === 'error') {
                return chip;
            }
            if (this.nbelements > 0) {
                return 'primary';
            } else {
                return 'secondary';
            }
        },
        borderChip(chip) {
            if (this.object === 'tasks') {
                return this.chipColor(chip);
            }
        },
        async addTask(relatedid, linkedType, step) {
            Activities.openActivityForm(
                null,
                relatedid,
                linkedType,
                () => {
                    EventBus.emit('form:opportunity:edit:success', { stepId: step });
                },
                'task',
            );
            const popupListing = document.getElementsByClassName('listing-dropdown');
            if (popupListing) {
                for (let i = 0; i < popupListing.length; i++) {
                    popupListing[i].style.display = 'none';
                }
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.content-header {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    padding-right: var(--spacing-3);

    &__title {
        padding: var(--spacing-2) var(--spacing-3);
    }
}
</style>
